module.exports = "<a  mdbBtn color=\"primary\" mdbWavesEffect>PayPal</a>"